export default "__VITE_ASSET__05eae7eb__"